import { TAnyTask } from 'lib/common/contexts/ContactContext';

export default function hasDraftContact(task: TAnyTask) {
  return !task.contact?.toSnapshot;
}
